import axios from "axios";
import { getCenterAddress, getPackageInvoice, invoiceVerificationOtpMachine, packageInvoice, packageStats } from "../../constants/apis/clinic_apis";
import { getUserRole, getUserToken } from "../../utils/localStoarege";

export const getAddress = async (centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(getCenterAddress + centerName, config);
    return response;
};

export const getInvoices = async (centerName, query) => {
    const cn = centerName !== "null" ? centerName : "";
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    if (getUserRole() === "operator") {
        const response = await axios.get(getPackageInvoice + centerName + query || "", config);
        return response;
    } else {
        const response = await axios.get(getPackageInvoice + cn + query || "", config);
        return response;
    }
};

export const getInvoiceStats = async (centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(packageStats + centerName + "/", config);
    return response;
};

export const addNewInvoices = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(packageInvoice, data, config);
    return response;
};

export const patchInvoices = async (id, status) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(`${packageInvoice}${id}`, { "status": status, }, config);
    return response;
};

export const sendInvoiceVericifationOtp = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(invoiceVerificationOtpMachine, data, config);
    return response;
};
